import { rd, RemoteData } from '@passionware/monads';
import { CrossfadeLayers } from 'v5/primitives/CrossfadeLayers';
import { FadeInImage } from 'v5/primitives/FadeInImage';

export interface EntityHeaderBackgroundImageProps {
  imageUrl: RemoteData<string>;
}

export const EntityHeaderBackgroundImage = ({
  imageUrl
}: EntityHeaderBackgroundImageProps) => {
  return (
    <div className="size-full relative overflow-hidden group">
      <CrossfadeLayers
        layerKey={
          imageUrl.status === 'success'
            ? `src:${imageUrl.data}`
            : imageUrl.status
        }
        className="size-full"
      >
        {rd
          .fullJourney(imageUrl)
          .initially(<div className="size-full bg-bg-emphasis" />)
          .wait(<div className="size-full bg-bg-subtle" />)
          .catch(error => <div className="w-full h-full bg-bg-danger"></div>)
          .map(imageUrl => (
            // The slow hover zoom on a wrapper: the picture's own transition is its fade-in.
            <div className="absolute size-full transition-all duration-3000 ease-in-out group-hover:scale-150">
              <FadeInImage
                src={imageUrl}
                alt="Background"
                className="size-full object-cover"
              />
            </div>
          ))}
      </CrossfadeLayers>
      {/* Over every layer: a crossfade blends two blurred pictures. */}
      <div className="absolute inset-0 backdrop-blur-[1.5rem]" />
    </div>
  );
};
